/**
 * `/assistant` — platform-wide AI assistant usage board (CC-440).
 *
 * Owns the validated search params. Pagination AND sort live in the URL: sort
 * is executed server-side across the whole tenant set, so the ordering is part
 * of the query, not a view preference — a deep link has to reproduce it.
 *
 * Defaults mirror the API's own (percentUsed DESC): the tenants closest to
 * their monthly wall first.
 */
import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";
import { AssistantUsageBoardScreen } from "../features/assistant/AssistantUsageBoardScreen";

const assistantSearchSchema = z.object({
  limit: z.coerce.number().int().positive().max(100).default(25),
  offset: z.coerce.number().int().nonnegative().default(0),
  sort: z.enum(["percentUsed", "spendMicros", "slug"]).default("percentUsed"),
  order: z.enum(["desc", "asc"]).default("desc"),
});

export const Route = createFileRoute("/_auth/assistant")({
  staticData: {
    breadcrumb: { labelKey: "nav.assistant" },
  },
  validateSearch: assistantSearchSchema,
  component: AssistantUsageBoardScreen,
});
